import React from "react";
import styled from "styled-components";

const StyledIconButton = styled.button`
  border-radius: 50%;
`;

const IconButton = ({ children, ...props }) => {
  return <StyledIconButton {...props}>{children}</StyledIconButton>;
};

export default IconButton;
